<template>
    <div>
        <ollaHead class="header" :isScroll="isScroll" @changeShowAddr="changeShowAddr"></ollaHead>

        <div class="indexMain">
            <div class="main1">
                <div class="main1_t1">OLLA<br>あなたの海外生活サポート</div>
                <div class="main1_t2">
                    より重要な物事に集中できる環境を整え、温かみと気配りにあふれたプラットフォームを築くことに努めています。
忙しい日常の中で、家庭のような快適さと安心感を感じていただけるようサポートいたします。
                </div>
                <div class="d-f tabs">
                    <div @click="scrollToAnchor('souji')" class="main1_tab">
                        <img src="../../assets/icon_clean.png"/>
                        <div class="tab_text">クリーン</div>
                    </div>
                    <div @click="scrollToAnchor('repair')" class="main1_tab">
                        <img src="../../assets/icon_repair.png"/>
                        <div class="tab_text">修理</div>
                    </div>
                    <div @click="scrollToAnchor('run')" class="main1_tab">
                        <img src="../../assets/icon_run.png"/>
                        <div class="tab_text">使い走り</div>
                    </div>
                    <div @click="scrollToAnchor('chef')" class="main1_tab">
                        <img src="../../assets/icon_chef.png"/>
                        <div class="tab_text">シェフ</div>
                    </div>
                    <div @click="scrollToAnchor('pets')" class="main1_tab">
                        <img src="../../assets/icon_pets.png"/>
                        <div class="tab_text">ペット</div>
                    </div>
                </div>
            </div>

            <div class="d-f tabTitle">
                <img class="iconTitle" src="../../assets/icon_title.png"/>
                <div class="titleText">特化サービス</div>
                <img class="iconTitle" src="../../assets/icon_title.png"/>
            </div>

            <div id="souji" class="souji divSouji">
                <div class="divSouji_d1">
                    <div class="soujiTop">
                        <img src="../../assets/souji_img_1.png"/>
                        <div>OLLA CLEAN — あなたの家庭清掃の専門家</div>
                        <div>効率的で専門的な清掃ソリューションを提供することに努めています。日常の掃除、深度清掃、専門的な設備や技術サポートが必要な清掃タスクまで、OLLA CLEANはあなたの家庭に刷新された清掃体験をもたらします
                        </div>
                    </div>
                    <img class="contextImg" src="../../assets/souji_img_5.png"/>
                </div>
                <div class="serveBoxs">
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/souji_img_2.png"/>
                            <div>日常清掃</div>
                            <div style="cursor: pointer;" @click="changeShowContext('clean-1')">サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                日常生活に必要な基本的な清掃サービスを提供し、住環境の整頓と衛生を保証します。私たちのチームはお客様のニーズに応じ、迅速かつ効率的に清掃作業を完了し、快適な居住環境を維持するお手伝いをします。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">¥<span>3300</span>円/時間（税込）～</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('clean-1')">料金説明</div>
                            </div>
                        </div>
                    </div>

                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/souji_img_4.png"/>
                            <div>専門清掃</div>
                            <div style="cursor: pointer;" @click="changeShowContext('clean-3')">サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                エアコン、換気扇、ソファ、カーペット、ベッドなどを含む各種家電家具の徹底的な清掃を提供。
ほこり・菌・ダニを完全除去し、効率的な汚れ落としで住まいを刷新。
簡単予約、細やかなサービスで、清潔で健康的な居住環境を実現します！
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>9900</span>円/件（税込）～</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('clean-3')">料金説明</div>
                            </div>
                        </div>
                    </div>

                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/souji_img_3.png"/>
                            <div>深度清掃</div>
                            <div style="cursor: pointer;" @click="changeShowContext('clean-2')">サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                日常的に掃除が難しい、またはあまり頻繁に手入れされないエリア向けに、専門的な深度清掃サービスを提供します。専門工具と専用洗剤・消毒剤などを使用し、家屋全体をメンテナンス。持続的な清潔さと保养効果を保証します。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>4500</span>円/時間（税込）～</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('clean-2')">料金説明</div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div id="repair" class="repair divRun">
                <div class="divSouji_d1">
                    <div class="runTop">
                        <img src="../../assets/repair_img_1.png"/>
                        <div>OLLA REPAIR — 信頼できる家居設置・修理の専門家</div>
                        <div>家電、家具、水道・電気・ガス設備などの専門的な設置と修理サービスに特化しています。経験豊富な技術者からなるチームが、効率的で信頼性の高いサービスを提供し、お客様の家居設備が正常に作動するよう保証します。快適で便利な生活をサポートします。
                        </div>
                    </div>
                    <img class="contextImg" src="../../assets/repair_img_2.png"/>
                </div>
                <div class="serveBoxs">
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/repair_img_3.png"/>
                            <div>設置・修理</div>
                            <div style="cursor: pointer;" @click="changeShowContext('repair-1')">サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                家電、家具、水道・電気・ガス設備など多様な機器をカバーし、すべての設置作業が安全性と機能性の要件を満たすことを保証します。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">料金は要相談</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('repair-1')">料金説明</div>
                            </div>
                        </div>
                    </div>
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/repair_img_4.png"/>
                            <div>配水管疏通</div>
                            <div style="cursor: pointer;" @click="changeShowContext('repair-2')">サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                            単管/総管/水道マンホール対応！高圧機械による徹底清掃、24時間出張サービスで詰まり問題を迅速解決！
                            </div>
                            <div class="servePrice">
                                <div class="f-1">料金は要相談</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('repair-2')">料金説明</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="run" class="run divRun">
                <div class="divSouji_d1">
                    <div class="runTop">
                        <img src="../../assets/run_img_2.png"/>
                        <div>OLLA RUN — あなたの生活アシスタント！お使い代行・雑務を手軽に解決</div>
                        <div>家庭向けお使い代行と事務代行に特化した専門サービスです。日常の雑事や複雑な事務処理を代行し、生活用品の購入、書類の配送、緊急時の対応など、あらゆるニーズに迅速かつ効率的に対応します。手間と時間を節約し、ストレスのない生活をサポートします。
                        </div>
                    </div>
                    <img class="contextImg" src="../../assets/run_img_1.png"/>
                </div>
                <div class="serveBoxs">
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/run_img_3.png"/>
                            <div>お使い代行サービス</div>
                            <div style="cursor: pointer;" @click="changeShowContext('run-1')">サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                多様な日常ニーズに対応し、手軽で迅速なソリューションを提供。自身で足を運ぶ手間を省きます。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2000</span>円/時間（税込）～</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('run-1')">料金説明</div>
                            </div>
                        </div>
                    </div>
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/run_img_4.png"/>
                            <div>代行サービス</div>
                            <div style="cursor: pointer;" @click="changeShowContext('run-2')">サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                多様な事務処理をカバー。日常生活における煩雑な事務を、専門的かつ効率的に解決します。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2000</span>円/時間（税込）～</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('run-2')">料金説明</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="chef" class="chef divRun">
                <div class="divSouji_d1">
                    <div class="runTop">
                        <img src="../../assets/chef_img_1.png"/>
                        <div>OLLA CHEF — あなた専用のプライベートシェフサービス～オーダーメイドの美食体験～</div>
                        <div>高級プライベートシェフサービスを提供し、ご家族にパーソナライズされた飲食体験をお届けします。日常の食事、家族団らん、特別な祝祭日においても、当社のシェフチームが心を込めて美味しい料理を調理し、ご自宅で五つ星の飲食サービスをお楽しみいただけます。
                        </div>
                    </div>
                    <img class="contextImg" src="../../assets/chef_img_2.png"/>
                </div>
                <div class="serveBoxs">
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/chef_img_3.png"/>
                            <div>プライベートシェフの出張サービス</div>
                            <div style="cursor: pointer;" @click="changeShowContext('chef-1')">サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                ご自宅でカスタマイズされた飲食体験を楽しめ、日常から特別な食事のニーズまでお応えします。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2000</span>円/時間（税込）～</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('chef-1')">料金説明</div>
                            </div>
                        </div>
                    </div>
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/chef_img_4.png"/>
                            <div>運転手・産後ケア師・住み込み家政婦</div>
                            <div style="cursor: pointer;" >サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
運転手・産後ケア師・住み込み家政婦、資格保有者在籍。ご要望に合わせたカスタマイズサービスで、安心・快適なサポートを全工程で提供します。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2000</span>円/時間（税込）～</div>
                                <div style="cursor: pointer;" >料金説明</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="pets" class="pets divRun">
                <div class="divSouji_d1">
                    <div class="runTop">
                        <img src="../../assets/pets_img_1.png"/>
                        <div>OLLA PETS — ペットケアの専門家、あなたのペットを一緒に守ります</div>
                        <div>ペット専門のプロサービスをご提供。短期出張、休暇、お仕事でお忙しい場合でも、ペットの心身の健康と幸福を守る包括的なお世話とお伴をいたします。
                        </div>
                    </div>
                    <img class="contextImg" src="../../assets/pets_img_2.png"/>
                </div>
                <div class="serveBoxs">
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/pets_img_3.png"/>
                            <div>ペット餌やりサービス</div>
                            <div style="cursor: pointer;" @click="changeShowContext('pets-1')">サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                在您外出期间，OLLA PETS为您的宠物提供安全、舒适的喂养环境。我们的专业人员上门喂养，确保它们得到悉心的照料，包括定时喂食、活动和卫生护理。您可以放心外出，宠物将在我们温馨的环境中度过轻松愉快的时光。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2800</span>円/時間（税込）～</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('pets-1')">料金説明</div>
                            </div>
                        </div>
                    </div>
                    <div class="serveBox">
                        <div class="d-f p-r serveBoxTop">
                            <img src="../../assets/pets_img_4.png"/>
                            <div>遛狗服务</div>
                            <div style="cursor: pointer;" @click="changeShowContext('pets-2')">サービス内容</div>
                        </div>
                        <div class="serveBoxbottom">
                            <div class="serveContext">
                                お忙しいペットオーナー様へ、OLLA PETSは犬の散歩サービスを提供します。専門チームがワンちゃんの日常ニーズに合わせ、散歩や運動にお連れし、十分な運動と外出時間を確保。散歩は身体の健康維持だけでなく、ストレスや不安の緩和にも繋がり、愛犬の幸福と満足度を守ります。
                            </div>
                            <div class="servePrice">
                                <div class="f-1">￥<span>2800</span>円/時間（税込）～</div>
                                <div style="cursor: pointer;" @click="changeShowPrice('pets-2')">料金説明</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-f tabTitle">
                <img class="iconTitle" src="../../assets/icon_title.png"/>
                <div class="titleText">ソーシャルメディアアカウント</div>
                <img class="iconTitle" src="../../assets/icon_title.png"/>
            </div>

            <div class="okerBottom">
                <img class="oker" src="../../assets/oker.png"/>
                <div class="b_d1">フォローして、もっと精彩なコンテンツを発見しましょう</div>
                <div class="b_d2">OLLAの小红书アカウントをスキャンして最新情報をゲット！私たちのコミュニティに参加して、いつでもどこでも生活のインスピレーションを共有し、素敵な瞬間をもっと発見しましょう！</div>
                <div class="qr qr_guanfang">
                    <img src="../../assets/qr_guanfang.png"/>
                    <div>OLLA 公式アカウント</div>
                </div>

                <div class="qr qr_run">
                    <img src="../../assets/qr_guanfang2.png"/>
                    <div>OLLA CLEAN 公式アカウント</div>
                </div>
            </div>
        </div>
    </div>

    <el-dialog
        v-model="showAddr"
        title=""
        :width="dialogWidth"
        center
    >
        <div slots="title" class="diaTitle">サービス範囲</div>
        <div v-for="item in addrs" v-bind:key="item">
            <div class="dialogCity">· {{ item.city }}</div>
            <div class="dialogArea">
                <span v-for="area in item.areas" v-bind:key="area">{{ area }} > </span>
            </div>
        </div>
    </el-dialog>
    <el-dialog
        v-model="showContext"
        title=""
        center
        :width="dialogWidth"
    >
        <div v-if="serveType=='clean-1'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogBody">・スタッフは基本工具を携行</div>
                <div class="dialogBody">・除塵サービス：クリーナーまたは静電除塵工具で室内の埃を除去</div>
                <div class="dialogBody">・床清掃：掃除、モップ掛け、クリーニングで清潔を維持</div>
                <div class="dialogBody">・デスク及び家具の清掃：デスク、キャビネット、ソファ等の家具の埃と汚れを除去</div>
                <div class="dialogBody">・キッチン清掃：コンロ表面、キャビネット表面、カウンター、シンクの油汚れと汚れを除去</div>
                <div class="dialogBody">・浴室・洗面台・トイレ清掃：浴室、浴槽、トイレ、洗面台などの水垢とカビを除去（一部の頑固な水垢は専門処理が必要な場合あり）</div>
                <div class="dialogBody">・ゴミ処理：室内のゴミ収集、ゴミ袋交換、ゴミ箱清掃</div>
            </div>
        </div>
        <div v-if="serveType=='clean-2'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogBody">・スタッフは基本工具を携行</div>
                <div class="dialogBody">・窓清掃：窓ガラス、枠の埃・汚れ・水垢を除去</div>
                <div class="dialogBody">・浴室ガラス清掃：頑固な水垢と汚れを徹底除去</div>
                <div class="dialogBody">・バルコニー清掃：床、手すり、窓及び植物の埃を除去</div>
                <div class="dialogBody">・庭とテラス清掃：庭やテラスの掃除、植物や户外家具の整理</div>
                <div class="dialogBody">・壁と天井清掃：壁面、天井の埃、蜘蛛の巣、汚れを除去</div>
                <div class="dialogBody">・キャビネット内部清掃：内部の整理と清掃</div>
                <div class="dialogBody">・特殊素材の家具や装飾品のクリーニングと保养</div>
                <div class="dialogBody">・観葉植物の埃除去：葉の表面の塵を清掃</div>
            </div>
        </div>
        <div v-if="serveType=='clean-3'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogBody">・エアコン清掃：フィルターや外装の埃・カビを除去</div>
                <div class="dialogBody">・冷蔵庫清掃：内部の消臭及び冷凍庫のクリーニング</div>
                <div class="dialogBody">・オーブンと電子レンジ清掃：内部の食品残渣や油汚れを除去</div>
                <div class="dialogBody">・レンジフードと換気扇清掃：換気口の油脂と埃を除去</div>
                <div class="dialogBody">・床ワックス掛けと研磨</div>
            </div>
        </div>
        <div v-if="serveType=='run-1'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogTitle">・買い物代行：</div>
                <div class="dialogBody">・日用品購入：食品、飲料、清掃用品等の生活必需品の購入と配達</div>
                <div class="dialogBody">・薬局代行：病気や外出困難な方の医薬品購入と配送</div>
                <div class="dialogBody">・スーパー買い出し：生鮮食品（野菜、果物、肉類等）の代購</div>
            </div>
            <div>
                <div class="dialogTitle">・物品配送：</div>
                <div class="dialogBody">・書類配送：重要書類の安全かつ迅速な配送</div>
                <div class="dialogBody">・荷物受発送：宅配便の代行送受付</div>
                <div class="dialogBody">・ギフト配送：誕生日や記念日等の贈り物の代行配送</div>
            </div>
            <div>
                <div class="dialogTitle">・食事関連：</div>
                <div class="dialogBody">・テイクアウト受取：注文済みの食事の受取と配送</div>
                <div class="dialogBody">・レストラン予約：宴会やイベント時の食事手配</div>
            </div>
            <div>
                <div class="dialogTitle">・日常業務：</div>
                <div class="dialogBody">・修理業者手配：専門業者の手配とアポイント調整</div>
                <div class="dialogBody">・送迎サービス：修理品などの短距離輸送</div>
            </div>
            <div>
                <div class="dialogTitle">・ペット関連：</div>
                <div class="dialogBody">・ペットフード購入：ペット用品の購入代行</div>
                <div class="dialogBody">・ペット送迎：動物病院や美容院への送迎</div>
            </div>
            <div>
                <div class="dialogTitle">・行列代行：</div>
                <div class="dialogBody">・医院受付：混雑時の診察予約代行</div>
                <div class="dialogBody">・イベント列：人気施設やチケットの行列代行</div>
            </div>
        </div>
        <div v-if="serveType=='run-2'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogTitle">・公共料金納付：</div>
                <div class="dialogBody">・水道/光熱費：水道光熱費の支払代行</div>
                <div class="dialogBody">・通信費：電話/インターネット料金の処理</div>
                <div class="dialogBody">・管理費：不動産管理費や駐車場料金の納付</div>
            </div>
            <div>
                <div class="dialogTitle">・書類手続：</div>
                <div class="dialogBody">・証明書申請：身分証、パスポート、運転免許等の手続代行</div>
                <div class="dialogBody">・銀行業務：振込、入出金、口座開設等の代行（銀行規定による）</div>
            </div>
            <div>
                <div class="dialogTitle">・行政手続：</div>
                <div class="dialogBody">・ビザ申請：必要書類の準備と提出代行</div>
                <div class="dialogBody">・税務処理：納税及び関連書類の手続代行</div>
            </div>
            <div>
                <div class="dialogTitle">・緊急対応：</div>
                <div class="dialogBody">・緊急修理：停電や水道トラブル時の業者手配</div>
                <div class="dialogBody">・緊急購入：緊急時の必需品や医薬品の調達</div>
            </div>
        </div>
        <div v-if="serveType=='chef-1'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogBody">・日常食事：朝食/昼食/夕食の定期的な調理サービス（家庭料理から高級料理まで）</div>
                <div class="dialogBody">・オーダーメイドメニュー：食事制限や健康状態に応じた対応（ベジタリアン、糖質制限等）</div>
                <div class="dialogBody">・家庭宴会：誕生日やパーティー用の特別コース（前菜、主菜、デザート含む）</div>
                <div class="dialogBody">・国際料理：フランス、日本、イタリア等の各国料理の提供</div>
            </div>
        </div>
        <div v-if="serveType=='chef-2'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogBody">・健康食事療法：減塩、低脂肪、グルテンフリー等の特別対応</div>
                <div class="dialogBody">・子供向け食事：栄養バランスの取れた美味しい食事の提供</div>
                <div class="dialogBody">・高齢者向け食事：消化しやすく栄養価の高いメニュー構成</div>
            </div>
        </div>
        <div v-if="serveType=='pets-1'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogBody">・指定時間の餌やり、遊び、散歩、活動区域の清掃を含む</div>
            </div>
            <div>
                <div class="dialogTitle">・注意事項：</div>
                <div class="dialogBody">・ペット用品及び食物はユーザー自身で準備</div>
            </div>
        </div>
        <div v-if="serveType=='pets-2'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogBody">・犬の需求に応じた散歩や運動により、十分な運動と户外活動を確保</div>
            </div>
        </div>
        <div v-if="serveType=='repair-1'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogTitle">・家電設置：</div>
                <div class="dialogBody">・テレビ：壁掛け設置と調整</div>
                <div class="dialogBody">・エアコン：壁掛け/床置きタイプの取り付けと調整</div>
                <div class="dialogBody">・冷蔵庫/洗濯機：給排水/電気接続と調整</div>
                <div class="dialogBody">・厨房家電：レンジフード、コンロ、食洗機、消毒庫の設置</div>
            </div>
            <div>
                <div class="dialogTitle">・家具組立：</div>
                <div class="dialogBody">・組み立て家具：ベッド、ソファ、キャビネット、桌椅等の組立</div>
                <div class="dialogBody">・オーダーメイド家具：衣装棚、本棚等の設置</div>
            </div>
            <div>
                <div class="dialogTitle">・水回り設置：</div>
                <div class="dialogBody">・水道工事：キッチン/浴室の配管接続と修理</div>
                <div class="dialogBody">・電気工事：スイッチ、コンセント、照明器具の取り付け</div>
                <div class="dialogBody">・ガス工事：ガス配管と給湯器の設置</div>
            </div>
            <div>
                <div class="dialogTitle">・内装関連：</div>
                <div class="dialogBody">・ドア/窓設置：室内ドア、外部ドア、窓の取り付け</div>
                <div class="dialogBody">・床設置：フローリング、タイル等の施工</div>
                <div class="dialogBody">・壁処理：壁紙、タイル、塗装の施工</div>
            </div>
            <div>
                <div class="dialogTitle">・通信設備設置：</div>
                <div class="dialogBody">・ルーター：無線LANの設定と設置</div>
                <div class="dialogBody">・弱電システム：ホームシアター、オーディオシステムの配線</div>
            </div>
        </div>
        <div v-if="serveType=='repair-2'">
            <div slots="title" class="diaTitle">サービス内容</div>
            <div>
                <div class="dialogTitle">・家具修理：</div>
                <div class="dialogBody">・木製家具：裂傷、擦り傷の修復</div>
                <div class="dialogBody">・皮革家具：皮革の裂け目、色褪せの修復</div>
                <div class="dialogBody">・組み立て家具：損傷部品の交換、扉の調整</div>
            </div>
            <div>
                <div class="dialogTitle">・水回り修理：</div>
                <div class="dialogBody">・配管修理：破裂、詰まり、漏水対応</div>
                <div class="dialogBody">・蛇口/バルブ：漏水、緩みの交換修理</div>
                <div class="dialogBody">・電気回路：断線、短路、コンセント不良の修理</div>
                <div class="dialogBody">・照明修理：器具故障、電球交換、スイッチ不具合</div>
            </div>
            <div>
                <div class="dialogTitle">・ガス修理：</div>
                <div class="dialogBody">・ガス漏れ：配管の点検と修復</div>
                <div class="dialogBody">・ガス給湯器：点火不良、水温異常、漏水の修理</div>
            </div>
            <div>
                <div class="dialogTitle">・ドア/窓修理：</div>
                <div class="dialogBody">・ドアロック：鍵詰まり、鍵芯交換</div>
                <div class="dialogBody">・枠修理：変形、緩み、開閉不良の修正</div>
                <div class="dialogBody">・レール修理：引き戸/窓のレール動作不良</div>
                <div class="dialogBody">・気密性改善：漏風、漏水の防止処理</div>
            </div>
            <div>
                <div class="dialogTitle">・壁/床修理：</div>
                <div class="dialogBody">・壁補修：ひび割れ、剥離、漏水補修</div>
                <div class="dialogBody">・床補修：フローリングの反り、傷修正</div>
                <div class="dialogBody">・タイル補修：割れ、剥がれの修復</div>
            </div>
            <div>
                <div class="dialogTitle">・衛生設備修理：</div>
                <div class="dialogBody">・トイレ：詰まり、漏水、水流不良の修理</div>
                <div class="dialogBody">・シャワー設備：シャワーヘッド、蛇口、排水管の修理</div>
                <div class="dialogBody">・防水処理：浴室の漏水防止修繕</div>
            </div>
        </div>
    </el-dialog>

    <el-dialog
        v-model="showPrice"
        title=""
        :width="dialogWidth"
        center
    >
        <div v-if="serveType=='clean-1'">
            <div slots="title" class="diaTitle">
                料金説明-日常清掃
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・サービス料金：3,300円/時間。最低予約時間：2時間から</div>
                <div class="dialogBody">・交通費：880円/作業員1名につき</div>
                <div class="dialogBody">・作業員人数：通常1名。特別なご要望がある場合は予約時にお申し付けください</div>
            </div>
            <div>
                <div class="dialogTitle">・総費用例：</div>
                <div class="dialogBody">・2時間清掃サービス：6,600円 + 880円交通費 = 7,480円</div>
                <div class="dialogBody">・3時間清掃サービス：9,900円 + 880円交通費 = 10,780円</div>
            </div>
            <div class="dialogRed">・注：追加要件または定期清掃プランについては、カスタム見積もりをご相談ください</div>
        </div>
        <div v-if="serveType=='clean-2'">
            <div slots="title" class="diaTitle">
                料金説明-深度清掃
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・サービス料金：作業難易度により4,500円/時間～。バルコニー・テラスは面積により計算（10㎡まで8,000円、以降10㎡毎に4,000円追加）。最低予約時間：2時間から</div>
                <div class="dialogBody">・交通費：880円/作業員1名につき</div>
                <div class="dialogBody">・作業員人数：清掃範囲と難易度により1～2名を派遣</div>
            </div>
            <div>
                <div class="dialogTitle">・特別項目別料金（別途見積）：</div>
                <div class="dialogBody">・窓清掃：窓数（面積）と難易度により現地評価後に見積もり</div>
                <div class="dialogBody">・特殊素材家具保养：素材と難易度により別途相談</div>
                <div class="dialogBody">・庭園清掃：面積と内容により現地評価後に見積もり</div>
            </div>
            <div>
                <div class="dialogTitle">・総費用例：</div>
                <div class="dialogBody">・2時間深度清掃（1名）：9,000円 + 880円交通費 = 9,880円</div>
                <div class="dialogBody">・3時間深度清掃（2名）：13,500円 + 1,760円交通費 = 15,260円</div>
            </div>
        </div>
        <div v-if="serveType=='clean-3'">
            <div slots="title" class="diaTitle">
                料金説明-専門清掃
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・サービス料金：冷蔵庫、エアコン、オーブン等は基本従量制</div>
                <div class="dialogBody">・交通費：880円/作業員1名につき</div>
            </div>
            <div>
                <div class="dialogTitle">・特別項目別料金：</div>
                <div class="dialogBody">・冷蔵庫清掃：9,000円/台</div>
                <div class="dialogBody">・壁掛けエアコン室内機：9,800円/台（2台目以降は2,000円引き/台）</div>
                <div class="dialogBody">・エアコン室外機：3,000円/台（2台目以降は1,000円引き/台）</div>
                <div class="dialogBody">・オーブン/電子レンジ：3,500円/台</div>
                <div class="dialogBody">・レンジフード：9,800円/台</div>
                <div class="dialogBody">・換気扇/通気口：3,500円/箇所</div>
                <div class="dialogBody">・床ワックス/研磨：面積と難易度により現地見積</div>
            </div>
            <div>
                <div class="dialogTitle">・総費用例：</div>
                <div class="dialogBody">・冷蔵庫清掃 + 交通費：9,000円 + 880円 = 9,880円</div>
                <div class="dialogBody">・エアコン室内機2台 + 交通費：17,600円 + 880円 = 18,480円</div>
            </div>
            <div class="dialogRed">・注：専門清掃の料金と時間は設備状況と現地評価により調整されます。詳細は予約時にお問い合わせください</div>
        </div>
        <div v-if="serveType=='run-1'">
            <div slots="title" class="diaTitle">
                料金説明-お使い代行
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・基本料：2,000円</div>
                <div class="dialogBody">・時間料金：3,300円/時間（2時間目以降は30分単位で計算）</div>
            </div>
            <div>
                <div class="dialogTitle">・交通費：</div>
                <div class="dialogBody">・基本交通費：880円（実費超過分は別途精算）</div>
            </div>
            <div>
                <div class="dialogTitle">・その他費用：</div>
                <div class="dialogBody">・代行購入費用は前払い、残金は終了後に返金</div>
            </div>
            <div>
                <div class="dialogTitle">・総費用例：</div>
                <div class="dialogBody">・1時間代行：2,000円 + 3,300円 + 880円 = 6,180円</div>
                <div class="dialogBody">・2時間代行：2,000円 + 6,600円 + 880円 = 9,480円</div>
            </div>
            <div class="dialogRed">・注：詳細な料金はサービス内容と実際の距離により異なります。予約時にご確認ください</div>
        </div>
        <div v-if="serveType=='run-2'">
            <div slots="title" class="diaTitle">
                料金説明-代行サービス
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・基本料：2,000円</div>
                <div class="dialogBody">・時間料金：3,300円/時間（2時間目以降は30分単位で計算）</div>
            </div>
            <div>
                <div class="dialogTitle">・交通費：</div>
                <div class="dialogBody">・基本交通費：880円（実費超過分は別途精算）</div>
            </div>
            <div>
                <div class="dialogTitle">・その他費用：</div>
                <div class="dialogBody">・代行購入費用は前払い、残金は終了後に返金</div>
            </div>
            <div>
                <div class="dialogTitle">・総費用例：</div>
                <div class="dialogBody">・1時間代行：2,000円 + 3,300円 + 880円 = 6,180円</div>
                <div class="dialogBody">・2時間代行：2,000円 + 6,600円 + 880円 = 9,480円</div>
            </div>
            <div class="dialogRed">・注：詳細な料金はサービス内容と実際の距離により異なります。予約時にご確認ください</div>
        </div>
        <div v-if="serveType=='chef-1'">
            <div slots="title" class="diaTitle">
                料金説明-プライベートシェフ
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・サービス料金：料理内容により3,630円/時間～</div>
                <div class="dialogBody">・最低予約時間：2時間から</div>
                <div class="dialogBody">・交通費：880円/シェフ1名につき</div>
                <div class="dialogBody">・人員配置：宴会規模により1～2名（要相談）</div>
            </div>
            <div>
                <div class="dialogTitle">・特別料金項目（別途見積）：</div>
                <div class="dialogBody">・高級食材：トリュフ、フォアグラ、ロブスター等は実費別途</div>
                <div class="dialogBody">・国際料理：メニュー難易度により詳細見積</div>
            </div>
            <div>
                <div class="dialogTitle">・総費用例：</div>
                <div class="dialogBody">・2時間シェフサービス（1名）：10,000円 + 880円 = 10,880円</div>
                <div class="dialogBody">・3時間宴会サービス（2名）：15,000円 + 1,760円 = 16,760円</div>
            </div>
            <div class="dialogRed">・注：料金と時間はメニューと食材により調整されます。予約時に詳細をご確認ください</div>
        </div>
        <div v-if="serveType=='chef-2'">
            <div slots="title" class="diaTitle">
                料金説明-特別食事サービス
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・健康食事：6,000円/食～</div>
                <div class="dialogBody">・子供向け食事：5,000円/食～</div>
                <div class="dialogBody">・高齢者向け食事：5,500円/食～</div>
                <div class="dialogBody">・基本料：2,000円</div>
                <div class="dialogBody">・最低注文数：1食から</div>
                <div class="dialogBody">・配送料：880円/回</div>
            </div>
            <div>
                <div class="dialogTitle">・特別オプション（別途見積）：</div>
                <div class="dialogBody">・栄養相談：栄養士によるアドバイスは別途相談</div>
            </div>
            <div>
                <div class="dialogTitle">・総費用例：</div>
                <div class="dialogBody">・健康食1食：6,000円 + 2,000円 + 880円 = 8,880円</div>
                <div class="dialogBody">・子供食2食：10,000円 + 2,000円 + 880円 = 12,880円</div>
            </div>
            <div class="dialogRed">・注：料金は要件とメニューにより調整されます。予約時に詳細をご確認ください</div>
        </div>
        <div v-if="serveType=='pets-1'">
            <div slots="title" class="diaTitle">
                料金説明-ペット餌やり
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・サービス料金：2,800円/時間</div>
                <div class="dialogBody">・交通費：880円/作業員1名につき</div>
            </div>
            <div>
                <div class="dialogTitle">・総費用例：</div>
                <div class="dialogBody">・2時間サービス：5,600円 + 880円 = 6,480円</div>
                <div class="dialogBody">・3時間サービス：8,400円 + 880円 = 9,280円</div>
            </div>
            <div class="dialogRed">・注：料金はペットの要件と状況により調整されます。予約時に詳細をご確認ください</div>
        </div>
        <div v-if="serveType=='pets-2'">
            <div slots="title" class="diaTitle">
                料金説明-犬の散歩
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・サービス料金：2,800円/時間（最低1時間から）</div>
                <div class="dialogBody">・交通費：880円/作業員1名につき</div>
            </div>
            <div>
                <div class="dialogTitle">・総費用例：</div>
                <div class="dialogBody">・1時間サービス：2,800円 + 880円 = 3,680円</div>
                <div class="dialogBody">・1.5時間サービス：4,200円 + 880円 = 5,080円</div>
            </div>
            <div class="dialogRed">・注：料金と時間は実際の要件により調整されます。予約時に詳細をご確認ください</div>
        </div>
        <div v-if="serveType=='repair-1'">
            <div slots="title" class="diaTitle">
                料金説明-設置サービス
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・サービス料金：要相談</div>
                <div class="dialogBody">・最低時間：プロジェクトにより異なる</div>
                <div class="dialogBody">・交通費：880円/作業員1名につき</div>
                <div class="dialogBody">・人員配置：作業範囲により1～2名</div>
            </div>
            <div class="dialogRed">・注：料金と時間は現地評価により調整されます。予約時に詳細をご確認ください</div>
        </div>
        <div v-if="serveType=='repair-2'">
            <div slots="title" class="diaTitle">
                料金説明-修理サービス
                <span style="color: #999999;">（税込）</span>
            </div>
            <div>
                <div class="dialogTitle">・料金説明（税込）：</div>
                <div class="dialogBody">・サービス料金：修理内容と材料費により要相談</div>
                <div class="dialogBody">・最低時間：プロジェクトにより異なる</div>
                <div class="dialogBody">・交通費：880円/作業員1名につき</div>
                <div class="dialogBody">・人員配置：修理規模により1～2名</div>
            </div>
            <div class="dialogRed">・注：料金と時間は現地評価により調整されます。予約時に詳細をご確認ください</div>
        </div>
    </el-dialog>

    <el-dialog
        v-model="showKefu"
        title=""
        :width="dialogWidth"
        center
    >
        <img style="width: 100%;height: auto;" src="../../assets/IG.png"/>
        <div style="text-align: center;font-size: 16px;">@OLLACLEAN</div>
        <div style="text-align: center;font-size: 16px;">IPHONE:07013191220</div>
    </el-dialog>

    <div class="phone">
        <div class="kefu">
            <div @click="openWx">IGサポート</div>
            <div>受付時間：年中無休</div>
        </div>
        <div class="fanwei" @click="changeShowAddr">サービス範囲</div>
    </div>

</template>

<script>
import ollaHead from "@/components/jp/ollaHead.vue";

export default {
    name: "ollaIndex",
    components: {
        ollaHead
    },
    data() {
        return {
            serveType: "",
            showContext: false,
            showPrice: false,
            showAddr: false,
            showKefu: false,
            addrs: [
    {
        "city": "東京都",
        "areas": [
            "中央区",
            "千代田区",
            "新宿区",
            "港区",
            "文京区",
            "台東区",
            "墨田区",
            "江東区",
            "品川区",
            "目黒区",
            "大田区",
            "世田谷区",
            "渋谷区",
            "中野区",
            "杉並区",
            "北区",
            "荒川区",
            "板橋区",
            "足立区",
            "葛飾区",
            "葛飾区",
            "江戸川区",
            "豊島区",
            "武蔵野市",
            "三鷹市",
            "調布市",
            "狛江市",
            "府中市",
            "国立市",
            "国分寺市",
            "立川市",
            "小金井市",
            "小平市",
            "西東京市",
            "町田市",
            "多摩市",
            "稲城市"
        ]
    },
    {
        "city": "神奈川県",
        "areas": [
            "中区",
            "南区",
            "西区",
            "緑区",
            "港北区",
            "旭区",
            "神奈川区",
            "鶴見区",
            "都筑区",
            "保土ヶ谷区",
            "都泉区",
            "磯子区",
            "金沢区",
            "港南区",
            "栄区",
            "瀬谷区",
            "戸塚区",
            "川崎区",
            "高津区",
            "幸区",
            "麻生区",
            "中原区",
            "宮前区",
            "多摩区"
        ]
    },
    {
        "city": "埼玉県",
        "areas": [
            "北区",
            "大宮区",
            "見沼区",
            "中央区",
            "桜区",
            "浦和区",
            "南区",
            "緑区",
            "岩槻区"
        ]
    }
],
            isScroll: "0",
            dialogWidth: "50vw",
        };
    },
    created() {
        this.setDialogWidth()
    },
    mounted() {
        document.title = "あなたの海外生活サポート";
        window.addEventListener('scroll', this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.setDialogWidth()
            })()
        }
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        setDialogWidth() {
            var val = document.body.clientWidth
            const def = 768 // 默认宽度
            if (val < def) {
                this.dialogWidth = '90vw';
            } else {
                this.dialogWidth = '50vw';
            }
        },
        handleScroll() {
            this.isScroll = window.scrollY > window.innerWidth * 0.1 ? "1" : "0";
        },
        scrollToAnchor(anchorId){
            const element = document.getElementById(anchorId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        },
        changeShowAddr(){
            this.showAddr = true;
        },
        changeShowContext(_serveType){
            this.showContext = true;
            this.serveType = _serveType;
        },
        changeShowPrice(_serveType){
            this.showPrice = true;
            this.serveType = _serveType;
        },
        openWx(){
            this.showKefu = true;
        }
    }
}
</script>

<style scoped>
.d-f {
    display: flex;
}

.f-1 {
    flex: 1;
}
.p-r{
    position: relative;
}

.header {
    position: fixed;
    width: 100vw;
    height: 6vw;
    z-index: 1000;
    padding: 0;
    opacity: 1;
}

.indexMain {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    margin-top: 0px;
    padding: 0;
    overflow-x: hidden;
}

.main1 {
    position: relative;
    width: 100vw;
    height: 47.2vw;
    background-image: url("../../assets/top_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
}

.main1_t1 {
    position: absolute;
    top: 8vw;
    left: 0vw;
    width: 100vw;
    text-align: center;
    color: white;
    font-size: 2.8vw;
}

.main1_t2 {
    position: absolute;
    top: 18vw;
    left: 30vw;
    color: white;
    font-size: 1.25vw;
    width: 40vw;
    text-align: center;
}

.tabs {
    position: absolute;
    top: 40vw;
    right: 2.8vw;
    width: 53.5vw;
    height: 4.72vw;
    background-color: white;
    border-radius: 4px;
}

.main1_tab {
    display: flex;
    cursor: pointer;
    flex: 1;
    justify-content: center;
    justify-items: center;
    align-items: center;
}

.main1_tab img {
    width: 2.5vw;
    height: 2.5vw;
    margin-right: 0.8vw;
}

.tab_text {
    font-size: 1.1vw;
    font-weight: bold;
}

.tabTitle{
    margin-top: 2.8vw;
    justify-content: center;
    align-items: center;
}

.iconTitle {
    width: 1.1vw;
    height: 1.7vw;
}

.titleText {
    font-size: 2vw;
    line-height: 2.8vw;
    font-weight: bold;
    margin: 0 0.5vw;
}

.divSouji {
    margin-top: 3vw;
    width: 100vw;
}
.divSouji_d1{
    display: flex;
}

.soujiTop {
    position: relative;
    width: 50vw;
    height: 33.3vw;
    background: #FFFCFC;
}

.soujiTop img {
    position: absolute;
    left: 8vw;
    top: 5.7vw;
    width: 6vw;
    height: 7vw;
}

.soujiTop div:nth-child(2) {
    position: absolute;
    left: 8vw;
    top: 10vw;
    font-size: 1.5vw;
    font-weight: bold;
}

.soujiTop div:nth-child(3) {
    position: absolute;
    left: 8vw;
    top: 13.75vw;
    width: 33.75vw;
    font-size: 1vw;
    line-height: 1.7vw;
}

.contextImg {
    width: 50vw;
    height: 33.3vw;
}

.serveBoxs{
    display: flex;
    margin-top: 3.3vw;
    margin-left: 8vw;
}

.divSouji .serveBox {
    width: 26.7vw;
    height: 20.7vw;
    box-shadow: 0.2vw 0.2vw 0.8vw 0px rgba(0, 0, 0, 0.05);
    border-radius: 0.8vw;
    margin-right: 1.7vw;
}
.divSouji .serveBoxTop img{
    width: 100%;
    height: 100%;
}
.divSouji .serveBoxTop div{
    position: absolute;
}

.divSouji .serveBoxTop div:nth-child(2){
    top:8.3vw;
    left: 2.8vw;
    font-weight: bold;
    font-size: 1.25vw;
    color: white;
    line-height: 2vw;
}
.divSouji .serveBoxTop div:nth-child(3){
    top:8.3vw;
    right: 1.7vw;
    font-size: 1vw;
    color: black;
    text-align: center;

    background: rgba(255,255,255,0.7);
    border-radius: 1.1vw;
    width: 6vw;
    height: 2vw;
    line-height: 2vw;
}

.divSouji .serveBoxbottom{
    margin: 0 1.7vw;
}
.divSouji .serveContext{
    margin-top: 1.1vw;
    font-size: 0.8vw;
    line-height: 1.4vw;
    color: #666666;
}

.divSouji .servePrice{
    display: flex;
    margin-top: 0.85vw;
}

.servePrice div:nth-child(1){
    font-size: 0.85vw;
    color: rgba(74, 16, 18, 1);

    span{
        font-size: 1.25vw;
        font-weight: bold;
        color: rgba(255, 78, 82, 1);
    }
}

.servePrice div:nth-child(2){
    font-size: 0.85vw;
    color: rgba(102, 102, 102, 1);
    font-weight: bold;
}


.divRun {
    margin-top: 5.5vw;
    width: 100vw;
}

.runTop {
    position: relative;
    width: 50vw;
    height: 33.3vw;
    background: #FFFCFC;
}

.runTop img {
    position: absolute;
    left: 8vw;
    top: 5.7vw;
    width: 6vw;
    height: 7vw;
}

.runTop div:nth-child(2) {
    position: absolute;
    left: 8vw;
    top: 10vw;
    font-size: 1.5vw;
    font-weight: bold;
}

.runTop div:nth-child(3) {
    position: absolute;
    left: 8vw;
    top: 13.75vw;
    width: 33.75vw;
    font-size: 1vw;
    line-height: 1.7vw;
}

.divRun .serveBox {
    width: 40.8vw;
    height: 20.7vw;
    box-shadow: 0.2vw 0.2vw 0.8vw 0px rgba(0, 0, 0, 0.05);
    border-radius: 0.8vw;
    margin-right: 1.7vw;
}
.divRun .serveBoxTop img{
    width: 100%;
    height: 100%;
}
.divRun .serveBoxTop div{
    position: absolute;
}

.divRun .serveBoxTop div:nth-child(2){
    top:10vw;
    left: 2.8vw;
    font-weight: bold;
    font-size: 1.25vw;
    color: white;
    line-height: 2vw;
}
.divRun .serveBoxTop div:nth-child(3){
    top:10vw;
    right: 1.7vw;
    font-size: 1vw;
    color: black;
    text-align: center;

    background: rgba(255,255,255,0.7);
    border-radius: 1.1vw;
    width: 6vw;
    height: 2vw;
    line-height: 2vw;
}

.divRun .serveBoxbottom{
    margin: 0 1.7vw;
}
.divRun .serveContext{
    margin-top: 1.7vw;
    font-size: 0.8vw;
    line-height: 1.4vw;
    color: #666666;
}
.divRun .servePrice{
    display: flex;
    margin-top: 1.4vw;
}


.pets .serveBoxTop div:nth-child(2){
    top:8.5vw;
}
.pets .serveBoxTop div:nth-child(3){
    top:8.5vw;
}
.pets .serveContext{
    margin-top: 1.2vw;
}

.okerBottom{
    position: relative;
    margin-top: 3vw;
    width: 100vw;
    height: 28vw;
    background: #FFFCFC;

    .b_d1{
        position: absolute;
        left: 8vw;
        top: 9.8vw;
        font-weight: bold;
        font-size: 1.5vw;
    }
    .b_d2{
        position: absolute;
        width: 33.8vw;
        left: 8vw;
        top: 14vw;
        font-size: 1vw;
        line-height: 1.7vw;
        color: #666666;
    }

    .oker{
        position: absolute;
        left: 8vw;
        top: 5.8vw;
        width: 16.25vw;
        height: 7vw;
    }

    .qr_guanfang{
        position: absolute;
        left: 67.4vw;
        top: 9.5vw;
    }

    .qr_run{
        position: absolute;
        left: 81.25vw;
        top: 9.5vw;
    }

    .qr{
        text-align: center;
        img{
            width: 7vw;
            height: 7vw;
        }
        div{
            margin-top: 0.5vw;
            text-align: center;
            font-size: 1vw;
            color: #000000;
        }
    }
}

.diaTitle{
    text-align: center;
    font-weight: bold;
    font-size: 1vw;
}

.dialogCity{
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 1vw;
    line-height: 1.6vw;
    margin: 0 1vw;
}
.dialogArea{
    font-family: PingFang SC, PingFang SC;
    font-size: 0.8vw;
    color: #666666;
    line-height: 1.6vw;
    margin: 0 2vw;
    font-weight: 400;
}

.dialogTitle{
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 1vw;
    line-height: 1.6vw;
    margin: 0 1vw;
}
.dialogBody{
    font-family: PingFang SC, PingFang SC;
    font-size: 0.8vw;
    color: #666666;
    line-height: 1.6vw;
    margin: 0 2vw;
    font-weight: 400;
}

.dialogRed{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 0.8vw;
    line-height: 1.6vw;
    margin: 0 1vw;
    color: #FF4E52;
}

.phone{
    display: none;
}

@media (max-width: 768px) {
    .header {
        height: 48px;
    }

    .main1 {
        background-image: url("../../assets/top_bg_phone.png")!important;
        height: 160vw!important;
    }
    .main1_t1{
        left: 16px;
        top: 150px;
        font-size: 20px;
    }
    .main1_t2{
        left: 16px;
        top: 232px;
        font-size: 14px;
        line-height: 22px;
        width: calc(100vw - 32px);
    }
    .tabs{
        top: calc(160vw - 44px);
        left: 16px;
        height: 88px;
        width: calc(100vw - 32px);
        box-shadow: 0.2vw 0.2vw 0.8vw 0px rgba(0, 0, 0, 0.05);
    }
    .main1_tab:nth-child(1){
        margin-left: 4vw;
    }
    .main1_tab:nth-child(5){
        margin-right: 4vw;
    }
    .main1_tab{
        display: block;
        text-align: center;
    }
    .main1_tab img{
        width: 32px!important;
        height: 32px!important;
        margin-top: 16px!important;
    }
    .main1_tab .tab_text{
        font-size: 14px;
        line-height: 24px;
        color: #4A1012;
    }
    .tabTitle{
        margin-top: 80px;
    }
    .tabTitle .iconTitle{
        width: 12px;
        height: 18px;
    }
    .tabTitle .titleText{
        font-size: 18px;
        line-height: 21px;
    }
    .divSouji_d1{
        display: block;
    }
    .soujiTop{
        width: 100vw;
        height: 180px;


    }
    .soujiTop div:nth-child(2){
        left: 28px;
        width: calc(100vw - 56px);
        font-size: 16px;
        line-height: 20px;
        top: 48px;
    }
    .soujiTop div:nth-child(3){
        left: 28px;
        width: calc(100vw - 56px);
        font-size: 12px;
        line-height: 20px;
        top: 86px;
    }
    .soujiTop img{
        width: 43px;
        height: 50px;
        left: 28px;
        top: 22px;
    }
    .contextImg{
        width: calc(100% - 32px);
        height: 66.9vw;
        margin-left: 16px;
        border-radius: 10px;
    }

    .runTop{
        width: 100vw;
        height: 200px;
    }
    .runTop div:nth-child(2){
        width: calc(100vw - 56px);
        left: 28px;
        font-size: 16px;
        line-height: 20px;
        top: 48px;
    }
    .runTop div:nth-child(3){
        width: calc(100vw - 56px);
        left: 28px;
        font-size: 12px;
        line-height: 20px;
        top: 86px;
    }
    .runTop img{
        width: 43px;
        height: 50px;
        left: 28px;
        top: 22px;
    }

    .serveBoxs{
        overflow-x: auto;
        margin-top: 24px;
        margin-left: 28px;
        display: -webkit-box;
    }
    .serveBox{
        width: 192px!important;
        height: auto!important;
        margin-right: 16px!important;
        border-radius: 15px!important;
    }
    .serveBoxTop{
        justify-content: center;
        overflow: hidden;
        height: 160px!important;
        border-radius: 15px 15px 0 0;
    }
    .serveBoxTop img{
        width: auto!important;
        border-radius: 15px 15px 0 0;
    }
    .serveBoxTop div:nth-child(2){
        left: 32px!important;
        top: 126px!important;
        font-size: 16px!important;
    }
    .serveBoxTop div:nth-child(3){
        top: 12px!important;
        right: 12px!important;
        width: 88px!important;
        height: 32px!important;
        font-size: 14px!important;
        line-height: 32px!important;
        border-radius: 20px!important;
    }
    .serveBoxbottom{
        margin: 0 16px!important;
    }
    .serveContext{
        font-size: 12px!important;
        line-height: 20px!important;
        margin-top: 16px!important;
    }
    .servePrice{
        display: block!important;
    }
    .servePrice div:nth-child(1){
        font-size: 10px;
        line-height: 12px;
        margin-top: 28px;
    }
    .servePrice div:nth-child(1) span{
        font-size: 16px!important;
        font-weight: bold!important;
        color: rgba(255, 78, 82, 1)!important;
    }
    .servePrice div:nth-child(2){
        font-size: 12px;
        margin-top: 10px;
        padding-bottom: 16px;
    }

    .okerBottom{
        height: 450px;
    }
    .okerBottom .oker{
        position: absolute;
        width: 117px!important;
        height: 50px!important;
        top: 24px!important;
        left: 28px!important;
    }
    .okerBottom .b_d1{
        position: absolute;
        top: 48px!important;
        left: 28px!important;
        font-size: 16px!important;
    }
    .okerBottom .b_d2{
        position: absolute;
        width: calc(100vw - 56px)!important;
        top: 90px!important;
        left: 28px!important;
        font-size: 12px!important;
        line-height: 20px!important;
    }
    .okerBottom .qr{
        text-align: center;
    }
    .okerBottom .qr img{
        width: 100px!important;
        height: 100px!important;
    }
    .okerBottom .qr div{
        font-size: 14px!important;
    }
    .okerBottom .qr_guanfang{
        position: absolute;
        top: 200px!important;
        left: 51px!important;
    }
    .okerBottom .qr_run{
        position: absolute;
        top: 200px!important;
        left: auto!important;
        right: 51px!important;
    }


    .diaTitle{
        font-size: 16px;
        margin-top: -30px;
    }

    .dialogCity{
        font-size: 14px;
        line-height: 28px;
        margin: 0 14px;
    }
    .dialogArea{
        font-size: 14px;
        line-height: 28px;
        margin: 0 24px;
        color: #999999;
    }

    .dialogTitle{
        font-size: 14px;
        line-height: 20px;
        margin: 5px 0;
    }
    .dialogBody{
        font-size: 14px;
        line-height: 20px;
        margin: 5px 12px;
        color: #999999;
    }

    .dialogRed{
        font-size: 12px;
        line-height: 20px;
        margin: 0 14px;
    }

    .phone{
        display: flex;
        position: fixed;
        bottom: 0;
        width: 100vw;
        height: 72px;
        background-color: white;
    }

    .kefu{
        text-align: center;
        background: rgba(255,78,82,0.12);
        border-radius: 20px;
        margin: 12px 12px 0 16px;
        height: 46px;
        width: calc(50vw - 28px);
    }
    .kefu div:nth-child(1){
        color: #FF4E52;
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        margin-top: 6px;
    }
    .kefu div:nth-child(2){
        color: #999999;
        font-size: 10px;
        line-height: 14px;
    }

    .fanwei{
        cursor: pointer;
        text-align: center;
        background: #FF4E52;
        border-radius: 20px;
        color: white;
        margin: 12px 0 0 12px;
        height: 46px;
        width: calc(50vw - 28px);
        line-height: 46px;
        font-size: 14px;
    }
}
</style>
